import _ from 'lodash';

import { PhoneNumberView } from '../../../../scenes/ConfirmAppointment/PhoneNumberView';
import { PracticeOnly } from '../common';

import styles from '../../index.module.css';
import ProviderImage from '../../../ProviderImage';

interface Props {
  config: PracticeOnly;
  distance: number | undefined;
}

const PracticeInfo: React.FC<Props> = ({ config, distance }) => {
  return (
    <div className={styles.MultiProviderInformationContainer}>
      <ProviderImage
        className={styles.MultiProviderImageContainer}
        provider={{
          firstName: config.name,
          lastName: '',
          previsitImageUrl: '',
        }}
        size="Small"
      />
      <div className={styles.MultiProviderNameContainer}>
        <div className={styles.MultiProviderName}>
          <div className={styles.ProviderName}>{config.name}</div>
          <div className={styles.Distance}>
            {!_.isNil(distance) ? `${distance.toFixed(1)}mi` : null}
          </div>
        </div>
        <div className={styles.MultiProviderLocation}>
          <div>
            <div>{config.address}</div>
            <div>{`${config.city}, ${config.state}`}</div>
          </div>
          <div className={styles.Distance}>
            {!_.isNil(distance) ? `${distance.toFixed(1)}mi` : null}
          </div>
        </div>
        <div className={styles.MultiProviderSpecialty}></div>
        {config.practicePhoneNumber && (
          <PhoneNumberView
            phoneNumber={config.practicePhoneNumber}
            className={styles.PhoneNumber}
          />
        )}
      </div>
    </div>
  );
};

export default PracticeInfo;
